import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/free-mode';
import { FreeMode } from 'swiper/modules';

const OEE = () => {
  return (
    <div id="main-wrapper">
      <Header />

      <div id="content" role="main">
        {/* Hero Section */}
        <section
          className="hero-wrap"
          style={{
            position: 'relative',
            overflow: 'hidden',
            minHeight: '60vh',
            display: 'flex',
            alignItems: 'center',
            backgroundImage: "url('/images/projects/realoeee.png')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className="container" style={{ position: 'relative', zIndex: 2, paddingTop: '70px' }}>
            <div className="row">
              <div className="col-12 text-center text-white">
                <h1 className="text-16 font-weight-600 mb-3 text-white">OEE</h1>
                <p className="lead text-white-100 mb-0">
                  Real-Time Manufacturing Intelligence and Predictive Insights to Maximize Efficiency, Availability, and Quality
                </p>
              </div>
            </div>
          </div>
          <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.5)', zIndex: 1 }}></div>
        </section>

        {/* Blog Intro */}
        <section className="py-5 bg-white text-dark">
          <div className="container">
            <div className="row align-items-center mb-5 g-4 flex-column-reverse flex-md-row"> 
              <div className="col-md-6 mb-4 mb-md-0"> 
                <img 
                  src="/images/projects/oee1.png" 
                  alt="Robots on Factory Floor" 
                  className="img-fluid rounded-4 shadow-lg"
                  style={{ height: '350px', objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="col-md-6">
                <h2 className="fw-bold mb-3">OEE: Real-Time Manufacturing Intelligence</h2>
                <p className="text-black" style={{ fontSize: "1rem" }}>
                 In modern manufacturing, efficiency, uptime, and product quality are critical. Yet, machines and production lines often operate in silos, limiting visibility into performance and downtime. Overall Equipment Effectiveness (OEE) bridges this gap by providing a unified metric to monitor, analyze, and optimize machine availability, performance, and quality—delivering actionable insights directly from the shop floor.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* What is RovoConnect */}
        <section className="py-5 bg-light text-dark">
          <div className="container">
            <div className="row mb-4">
              <div className="col-lg-10 mx-auto text-center">
                <h2 className="fw-bold mb-3">What is OEE?</h2>
                <p className="text-black" style={{ fontSize: "1rem" }}>
                  Overall Equipment Effectiveness (OEE) is a key manufacturing metric that shows how efficiently a machine or production line is performing compared to its full potential.

                  It helps manufacturers identify losses, downtime, and inefficiencies in their production process.
                </p>
              </div>
            </div>

            <div className="row g-4">
              {[
                { title: "OEE Overview", text: "Measure how effectively your machines perform against their maximum production potential.", icon: "bi bi-display", img: "/images/projects/oee1.png" },
                { title: "Availability Tracking", text: "Monitor machine uptime to identify breakdowns, stoppages, and lost production time.", icon: "bi bi-activity", img: "/images/projects/avat.png" },
                { title: "Performance Efficiencyn", text: "Analyze operating speed to detect slow cycles and minor production losses.", icon: "bi bi-robot", img: "/images/projects/per1.png" },
                { title: "Quality Output", text: "Track good vs defective output to improve product quality and reduce waste.", icon: "bi bi-clock", img: "/images/projects/qa.png" },
              ].map((feature, idx) => (
                <div className="col-12 col-md-6 col-lg-6 mb-4" key={idx}>
                  <div className="card h-100 border-0 shadow-lg rounded-4 overflow-hidden">
                    <img 
                      src={feature.img} 
                      alt={feature.title} 
                      className="card-img-top"
                      style={{ height: '250px', objectFit: 'cover', width: '100%' }} 
                    />
                    <div className="card-body">
                      <div className="mb-2 text-primary">
                        <i className={`${feature.icon} fs-2`}></i>
                      </div>
                      <h5 className="fw-bold mb-3">{feature.title}</h5>
                      <p className="text-muted mb-0">{feature.text}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Business Impact */}
        <section className="py-5 bg-light text-dark">
          <div className="container">
            <div className="row align-items-center g-4 flex-column-reverse flex-md-row">
              <div className="col-md-6">
                <h2 className="fw-bold mb-4">Business Impact</h2>
                <p className="text-black" style={{ fontSize: "1.50rem" }}>
                  Tracking and improving Overall Equipment Effectiveness (OEE) helps manufacturers maximize productivity, reduce costs, and make data-driven decisions.
                </p>
                <ul className="list-unstyled text-muted fs-20">
                  <li className="mb-2"> Reduce unplanned downtime and maintenance costs</li>
                  <li className="mb-2"> Improve machine performance and utilization</li>
                  <li className="mb-2"> Enhance product quality and minimize defects</li>
                  <li className="mb-2"> Optimize production throughput and energy efficiency</li>
                  <li className="mb-2"> Support informed, data-driven operational decisions</li>
                </ul>
              </div>

              <div className="col-md-6">
                <img
                  src="/images/projects/bus8.png"
                  alt="Business Impact"
                  className="img-fluid rounded-4 shadow-lg"
                  style={{ height: '400px', objectFit: 'cover', width: '100%' }}
                />
              </div>
            </div>
          </div>
        </section>

        {/* Key Features & Capabilities */}
        <section className="py-5 bg-white text-dark">
          <div className="container">
            <div className="row mb-4">
              <div className="col-lg-10 mx-auto text-center">
                <h2 className="fw-bold mb-3">Key Features & Capabilities</h2>
                <p className="text-muted mb-5">
                Monitor, analyze, and optimize equipment performance to maximize productivity and efficiency.
                </p>
              </div>
            </div>

            {/* Horizontal scrollable container */}
            <div
              className="d-flex flex-row flex-nowrap"
              style={{
                gap: "1rem",
                paddingBottom: "1rem",
                overflowX: "auto",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
              onWheel={(e) => {
                e.currentTarget.scrollLeft += e.deltaY;
              }}
            >
              <style>
                {`
                  div::-webkit-scrollbar {
                    display: none;
                  }
                  @media (max-width: 768px) {
                    .card {
                      min-width: 250px !important;
                      height: auto !important;
                    }
                    .card img {
                      height: 180px !important;
                    }
                  }
                `}
              </style>

              {[
                { title: "Real-Time OEE Monitoring", text: "Monitor machine efficiency, uptime, and performance metrics in real time to maximize productivity.", icon: "bi bi-collection", img: "/images/projects/oeereal.png" },
                { title: "Downtime Analysis", text: "Track and analyze unplanned stops, maintenance events, and bottlenecks to reduce lost production time.", icon: "bi bi-speedometer2", img: "/images/projects/down.png" },
                { title: "Performance & Productivity Insights", text: "Analyze production speed, cycle times, and throughput to identify efficiency improvements.", icon: "bi bi-bar-chart", img: "/images/projects/per12.png" },
                { title: "Quality & Defect Tracking", text: "Monitor product quality and defects, ensuring higher yield and minimal rework.", icon: "bi bi-controller", img: "/images/projects/qd.png" },
                // { title: "Protocol Agnostic", text: "Supports TCP/IP, Modbus, EtherNet/IP, and more.", icon: "bi bi-layers", img: "/images/projects/rovovision.png" },
                // { title: "Decision-Making", text: "Make smarter decisions using real-time insights from robots and PLCs.", icon: "bi bi-layers", img: "/images/projects/rovovision.png" },
              ].map((feature, idx) => (
                <div
                  key={idx}
                  className="card flex-shrink-0 border-0 shadow-lg rounded-4 overflow-hidden"
                  style={{ width: "300px" }}
                >
                  <img
                    src={feature.img}
                    alt={feature.title}
                    className="card-img-top"
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                  <div className="card-body">
                    <div className="mb-2 text-primary">
                      <i className={`${feature.icon} fs-2`}></i>
                    </div>
                    <h5 className="fw-bold mb-2">{feature.title}</h5>
                    <p className="text-muted mb-0">{feature.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Why Choose RovoConnect */}
        <section className="py-5 bg-light text-dark">
          <div className="container">
            <div className="row align-items-center g-4 flex-column-reverse flex-md-row">
              <div className="col-md-6">
                <img
                  src="/images/projects/why1.png"
                  alt="Why Choose RovoConnect"
                  className="img-fluid rounded-4 shadow-lg mb-4"
                  style={{ height: '400px', objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="col-md-6">
                <h2 className="fw-bold mb-4">Why Choose OEE?</h2>
                <p className="text-muted mb-4">Implementing Overall Equipment Effectiveness (OEE) helps manufacturers maximize productivity, reduce downtime, and improve quality across all production lines.RovoConnect combines cutting-edge technology and universal connectivity to deliver actionable insights and operational efficiency.
                </p>
                <ul className="list-unstyled text-muted fs-6">
                  <li className="mb-3"><strong>Real-Time Monitoring:</strong> Track machine performance, uptime, and productivity in real time.</li>
                  <li className="mb-3"><strong>Downtime Analysis:</strong> Identify and reduce unplanned stops and bottlenecks.</li>
                  <li className="mb-3"><strong>Performance Optimization:</strong>Measure production speed, cycle times, and throughput to improve efficiency.</li>
                  <li className="mb-3"><strong>Quality Tracking:</strong> Monitor defects and yield to ensure higher product quality.</li>
                  
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Conclusion & CTA */}
        <section className="py-5 bg-dark text-white text-center">
          <div className="container">
            <p className="lead mb-4 mx-auto" style={{ maxWidth: '800px' }}>
            Overall Equipment Effectiveness (OEE) is a powerful metric that helps manufacturers maximize productivity, reduce downtime, and improve product quality. By tracking availability, performance, and quality, OEE provides clear insights into operational efficiency and highlights areas for continuous improvement. Implementing OEE enables data-driven decision-making, optimizes resources, and drives sustainable manufacturing excellence.
            </p>
            <a href="/contact" className="btn btn-primary btn-lg rounded-pill px-5">Inquire About Partnership</a>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default OEE;
